















import {Component, Prop, Provide, Vue, Watch} from 'vue-property-decorator'
import {InputText} from 'simpli-web-sdk'
import {Validator} from 'vee-validate'

@Component({
  components: {InputText},
})
export default class PasswordConfirm extends Vue {
  @Prop({type: Boolean, default: true}) value!: boolean
  @Prop({type: Boolean, default: false}) required!: boolean
  @Prop({type: String, default: null}) password!: string | null
  @Prop({type: String, default: null}) label!: string | null
  @Prop({type: Object, default: null}) validator!: Validator | null

  confirmPassword = ''

  get valid() {
    return this.value
  }

  set valid(val: boolean) {
    this.$emit('input', val)
  }

  @Watch('confirmPassword')
  @Watch('password')
  onChange() {
    this.valid = Boolean(
      !this.confirmPassword ||
        !this.confirmPassword.length ||
        this.confirmPassword === this.password
    )
  }
}
